import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation login (
    $client_id: String!
    $client_secret: String!
    $grant_type: GrantType!
    $username: String!
    $password: String!
  ) {
    login (
      input: {
        client_id: $client_id
        client_secret: $client_secret
        grant_type: $grant_type
        username: $username
        password: $password
      }
    ) {
      success
      message
      createdAccessToken{
        access_token
        refresh_token
        token_type
        userId
      }
    }
  }
`

export const QUOTATION_REQUEST_CREATE = gql`
  mutation createRequest (
    $useBoxSuitDesign: Boolean
    $input: CreateQuotationInput
  ) {
    createRequest (
      input: $input
      useBoxSuitDesign: $useBoxSuitDesign
    ) {
      success
      message
      createdQuotation {
        quotationId
        refId
      }
    }
  }
`

export const CREATE_PAYMENT = gql`
  mutation createPayment (
    $quotationId: Int!
    $amount: Float!
    $date: String!
    $month: String!
    $year: String!
    $hour: String!
    $minute: String!
    $name: String!
    $paymentMethod: Method!
    $evidenceFiles: [Upload]!
  ) {
    createPayment (
      input: {
        quotationId: $quotationId
        amount: $amount
        date: $date
        month: $month
        year: $year
        hour: $hour
        minute: $minute
        name: $name
        paymentMethod: $paymentMethod
        evidenceFiles: $evidenceFiles
      }
    ) {
      success
      message
      createdPayment {
        paymentId
        name
      }
    }
  }
`
export const SIGNUP = gql`
  mutation signup (
    $email: String!
    $password: String!
  ) {
    signup (
      input: {
        email: $email,
        password: $password,
        userType: normal
      }
    ) {
      success
      message
      createdUser {
        userId
        email
        userType
        userStatus
        refreshToken
        facebookId
        googleId
      }
    }
  }
`

export const EDIT_PROFILE = gql`
  mutation editProfile (
    $input: EditProfileInput
  ) {
    editProfile (
      input: $input
    ) {
      success
      message
    }
  }
`

export const CHANGE_PASSWORD = gql`
  mutation changePassword (
    $oldPassword: String!
    $newPassword: String!
  ) {
    changePassword (
      input: {
        oldPassword: $oldPassword
        newPassword: $newPassword
      }
    ) {
      success
      message
    }
  }
`

export const FORGET_PASSWORD = gql`
  mutation forgetPassword (
    $email: String!
  ) {
    forgetPassword (
      input: {
        email: $email
      }
    ) {
      success
      message
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation resetPassword (
    $token: String!
    $newPassword: String!
  ) {
    resetPassword (
      input: {
        token: $token
        newPassword: $newPassword
      }
    ) {
      success
      message
    }
  }
`

export const RESEND_ACTIVATION = gql`
  mutation resendActivation (
    $email: String!
  ) {
    resendActivation (
      input: {
        email: $email
      }
    ) {
      success
      message
    }
  }
`

export const UPLOAD_GENERAL_FILE = gql`
  mutation uploadGeneralFile (
    $input: UploadGeneralFileInput
  ) {
    uploadGeneralFile (
      input: $input
    ) {
      success
      message
      files {
        uri
        name
      }
    }
  }
`

export default LOGIN



// WEBPACK FOOTER //
// ./src/constants/graph/mutation.js